/**
 * Regras de visibilidade das abas do Extrato.
 *
 * A barra de abas esconde abas conforme o perfil do jogador, mas o índice de
 * `activeTab` continua sendo o índice na lista COMPLETA. Manter as duas coisas
 * em sincronia era feito por dois blocos de `if` duplicados dentro da página;
 * aqui a lista visível e o mapa de índices saem da MESMA filtragem, então não
 * há como divergirem.
 */

export const EXTRATO_TABS = [
  'Resumo',
  'Reconhecimentos',
  'Realização <br /> Destaque',
  'Ações ECOA',
  'Ações de <br />Engajamento',
];

export const TAB_REALIZACAO_DESTAQUE = 2;
export const TAB_ACOES_ECOA = 3;

/**
 * Bloco `acao_ecoa` do resumo do ciclo (aggregate `extrato_resumo`). `total` é a
 * soma dos achievements `entrega_equipe_ecoa` e `summary` traz os 5 mais
 * recentes — a MESMA origem do conteúdo da aba, então usá-lo como gate garante
 * que a aba só apareça quando de fato houver o que mostrar.
 */
export interface AcaoEcoaSummary {
  total?: number;
  summary?: unknown[];
}

export interface EcoaTabVisibility {
  /** `userInfo.ecoa` — perfil ECOA vindo da requisição de player info. */
  userInfoEcoa?: string | false;
  /** `undefined` enquanto o resumo do ciclo não carregou. */
  acaoEcoa?: AcaoEcoaSummary;
}

/**
 * A aba ECOA aparece para quem tem o perfil no player info OU, na falta dele,
 * para quem tem alguma Ação ECOA no extrato do ciclo selecionado.
 */
export function shouldShowEcoaTab({ userInfoEcoa, acaoEcoa }: EcoaTabVisibility): boolean {
  if (userInfoEcoa) return true;
  if (!acaoEcoa) return false;

  return (acaoEcoa.total ?? 0) > 0 || (acaoEcoa.summary?.length ?? 0) > 0;
}

export interface ExtratoTabsContext {
  tipoDeAcordo?: string;
  showEcoaTab: boolean;
}

export interface ExtratoTabs {
  /** Rótulos das abas visíveis, na ordem em que são renderizadas. */
  labels: string[];
  /** `indexMap[índice visível]` = índice da aba na lista completa. */
  indexMap: number[];
}

export function resolveExtratoTabs({ tipoDeAcordo, showEcoaTab }: ExtratoTabsContext): ExtratoTabs {
  const indexMap = EXTRATO_TABS.map((_, index) => index).filter(index => {
    if (index === TAB_REALIZACAO_DESTAQUE && tipoDeAcordo === 'PREDEFINIDO') return false;
    if (index === TAB_ACOES_ECOA && !showEcoaTab) return false;

    return true;
  });

  return { labels: indexMap.map(index => EXTRATO_TABS[index]), indexMap };
}
